export const contactsSelector = state => state.contacts;